let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ffEVr"), load("kjZZD"), load("aGZFn"), load("faXeM")]).then(() => parcelRequire('antvm'));